<template>
  <Modal headerType="fail" :visible="visible" @close="handleClickClose">
    <div class="failContent">
      <div class="title">{{ $t('no_prize_model.title') }}</div>
      <img class="icon" src="../assets/images/lalamove-sad-face.png" />
      <div class="okBtn" @click="handleClickOk">
        {{ $t('no_prize_model.try_again') }}
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  methods: {
    handleClickOk() {
      this.$emit('close');
    },
    handleClickClose() {
      this.$emit('close');
    },
    reportExpo() {
      this.$emit('reportEvent', {
        event: 'lottery_popup_expo',
        module_name: 'thanks_popup'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.failContent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 40px;
  color: #333;
  font-weight: bold;
}

.icon {
  margin: 75px 0;
  width: 185px;
  height: 185px;
}

.okBtn {
  margin-bottom: 60px;
  width: 450px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: normal;
  background: linear-gradient(to top, #f16622 0%, #ffa400 100%);
  font-weight: bold;
  border-radius: 44px;
  font-size: 40px;
  color: #fff;
}
</style>
